import { render } from "./SalesReturnList.vue?vue&type=template&id=56b76a0e&scoped=true&ts=true"
import script from "./SalesReturnList.vue?vue&type=script&lang=ts"
export * from "./SalesReturnList.vue?vue&type=script&lang=ts"

import "./SalesReturnList.vue?vue&type=style&index=0&id=56b76a0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b76a0e"]])

export default __exports__